import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Form } from '@shared/models/form';
import { Observable } from 'rxjs';
import { Config } from '@core/config';
import { Option } from '@shared/models/option';
import { ResponseData } from '../models/temp-form';
import { CardList } from '../models/card-list';

@Injectable({
  providedIn: 'root',
})
export class FormsService {
  inspirationTags: ResponseData[] = [];
  fiches: CardList[] = [];
  constructor(private httpClient: HttpClient) {}

  getForms(): Observable<Form[]> {
    return this.httpClient.get<Form[]>(Config.serverUrl + 'form', {
      responseType: 'json',
    });
  }

  /**
   * En fonction de l'identifiant set depuis le formulaire, on va gérer les temps de durées depuis cette méthode
   * Ce qui permettra de filtrer les fiches circuit en fonction de leurs durée de réalisation, le type de circuit sera juste
   * définis en fonction du paramètre responseIdentificator.
   * @returns
   */
  getFilters() {
    let minTime: number = null;
    let maxTime: number = null;

    switch (this.inspirationTags[2]?.responseIdentificator) {
      case 1:
        maxTime = 1;
        break;
      case 2:
        minTime = 1;
        maxTime = 2;
        break;
      case 3:
        minTime = 2;
        break;
      case 4:
        maxTime = 2;
        break;
      case 5:
        minTime = 2;
        maxTime = 3.5;
        break;
      case 6:
        minTime = 3.5;
        break;
      default:
        break;
    }

    return {
      minTime: minTime,
      maxTime: maxTime,
      circuitType: this.inspirationTags[1]?.responseIdentificator,
    };
  }

  async getFormResults() {
    return this.httpClient
      .post<CardList[]>(Config.serverUrl + 'form/circuits', this.getFilters(), {
        responseType: 'json',
      })
      .toPromise()
      .then((result) => {
        if (result) {
          this.fiches = result;
        }
      });
  }
}
